import { Breadcrumbs, Navigate } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { AiItineraryNewQuote, useTrip } from "../../../Trips"
import { Spinner } from "@sembark-travel/ui-base"
import { useParams, generatePath } from "../../../router-utils"
import { useHasFeatureFlag } from "../../../Auth"
import { useState } from "react"

export default function AiItineraryNewQuotePage() {
	const { tripId } = useParams("/trips/:tripId/ai-itinerary-builder/new-quote")
	const { trip } = useTrip(tripId)
	const hasAIItineraryBuilder = useHasFeatureFlag("ai_itinerary_builder")
	const [isStreaming, setIsStreaming] = useState(true)
	function onStreamingChange(streaming: boolean) {
		setIsStreaming(streaming)
	}
	return (
		<>
			<Helmet>
				<title>AI Generated Quote</title>
			</Helmet>
			{!isStreaming ? (
				<Breadcrumbs
					title="AI Generated Quote"
					items={[
						[generatePath("/trips"), "Trips"],
						[generatePath("/trips/:tripId", { tripId }), trip?.name || tripId],
						[
							generatePath("/trips/:tripId/ai-itinerary-builder", { tripId }),
							"AI Itinerary Builder",
						],
						["", "AI Generated Quote"],
					]}
				/>
			) : null}
			{!trip ? (
				<Spinner alignCenter padding="4" />
			) : !hasAIItineraryBuilder ||
			  trip.is_locked ||
			  trip?.latest_given_quote ||
			  trip?.cancellation_reason ? (
				<Navigate to={generatePath("/trips/:tripId", { tripId })} replace />
			) : (
				<AiItineraryNewQuote
					trip={trip}
					onStreamingChange={onStreamingChange}
				/>
			)}
		</>
	)
}
